import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "AlignVerticalTop"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M18 15H15C14.6023 14.9995 14.221 14.8414 13.9398 14.5602 13.6586 14.279 13.5005 13.8977 13.5 13.5V8.25C13.5005 7.85232 13.6586 7.47105 13.9398 7.18984 14.221 6.90864 14.6023 6.75046 15 6.75H18C18.3977 6.75046 18.779 6.90864 19.0602 7.18984 19.3414 7.47105 19.4995 7.85232 19.5 8.25V13.5C19.4995 13.8977 19.3414 14.279 19.0602 14.5602 18.779 14.8414 18.3977 14.9995 18 15zM15 8.25V13.5H18.0009L18 8.25H15zM9 21H6C5.60232 20.9995 5.22105 20.8414 4.93984 20.5602 4.65864 20.279 4.50046 19.8977 4.5 19.5V8.25C4.50046 7.85232 4.65864 7.47105 4.93984 7.18984 5.22105 6.90864 5.60232 6.75046 6 6.75H9C9.39768 6.75046 9.77895 6.90864 10.0602 7.18984 10.3414 7.47105 10.4995 7.85232 10.5 8.25V19.5C10.4995 19.8977 10.3414 20.279 10.0602 20.5602 9.77895 20.8414 9.39768 20.9995 9 21zM6 8.25V19.5H9.0009L9 8.25H6zM22.5 3H1.5V4.5H22.5V3z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/AlignVerticalTop.vue"]]);
